import styled, { css } from 'styled-components'

import { ButtonAsync } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	isDanger?: boolean
	isInline?: boolean
}

const inlineCss = css`
	display: inline-block;
	padding: 8px 0;
	min-height: unset;
	min-width: unset;
	max-width: unset;
`

export const ButtonText = styled(ButtonAsync)<Props>`
	font-size: ${helpers.font.size.base};
	font-weight: 600;
	background-color: transparent;
	color: ${({ isDanger = false, theme }) => (isDanger ? theme.color.danger : theme.color.textButtonOpaque)};
	border-radius: 2px;
	min-height: 40px;
	min-width: 120px;
	max-width: 400px;
	padding: 8px 30px;
	margin: 0;
	height: unset;

	&:focus-visible {
		outline: 2px solid ${helpers.color.buttonFocus};
	}

	&:disabled {
		color: ${helpers.color.disabled};
		box-shadow: none;
	}

	.label {
		white-space: normal;
		overflow: visible;
		text-overflow: clip;
	}

	${({ isInline = false }) => isInline && inlineCss}
`
